import React from 'react';
import './Header.scss';
import UserStore from 'components/UserStore';

export default class Header extends React.Component {
  constructor(props) {
      super(props);

      this.state = {
          isLoggedIn: UserStore.isLoggedIn()
      }
  }

  render () {

    return (
      <header className="clearfix header-landing">
        <section className="container site-centered full-bl-header">
            <div className="row">
                <div className='header--flex--container'>
                    <div className='logo--holder'>
                        <a href="/">
                            <h1>
                                <svg style={{maxHeight: '55px'}} className="logo" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                                 x="0px" y="0px" viewBox="0 0 185.08 92.1" xmlSpace="preserve">
                                    <path className="st0" d="M488.54,352.05h-4.41a86.9,86.9,0,0,0-25.81-62,88.51,88.51,0,0,0-124.64,0,86.9,86.9,0,0,0-25.81,62h-4.41a91.26,91.26,0,0,1,27.11-65.16,92.93,92.93,0,0,1,130.86,0A91.26,91.26,0,0,1,488.54,352.05Z"
                                      transform="translate(-303.46 -259.95)"></path>
                                    <path className="st0" d="M367.19,298.57a12.61,12.61,0,1,1,12.6,12.61A12.61,12.61,0,0,1,367.19,298.57Zm12.61,8.1a8.1,8.1,0,1,0-8.11-8.1A8.1,8.1,0,0,0,379.8,306.67Z"
                                      transform="translate(-303.46 -259.95)"></path>
                                    <path className="st0" d="M412.21,311.18a12.61,12.61,0,1,1,12.6-12.61A12.61,12.61,0,0,1,412.21,311.18Zm8.1-12.61a8.11,8.11,0,1,0-8.11,8.1A8.11,8.11,0,0,0,420.31,298.57Z"
                                      transform="translate(-303.46 -259.95)"></path>
                                    <polygon className="st0" points="54.22 66.92 44.06 56.45 63.94 57.57 65.42 56.15 48.76 38.99 45.51 42.12 55.67 52.58 35.79 51.47 34.31 52.89 50.97 70.04 54.22 66.92"></polygon>
                                    <polygon className="st0" points="122.86 58.97 133.14 48.63 132.37 68.53 133.82 69.98 150.68 53.03 147.5 49.83 137.21 60.17 137.98 40.27 136.54 38.82 119.67 55.77 122.86 58.97"></polygon>
                                </svg>
                            </h1>
                        </a>
                    </div>
                    <div className='buttons-holder'>
                    {this.state.isLoggedIn && <a href="/login" id="loginbtn" className="header--btns">LOGOUT</a>}
                    {!this.state.isLoggedIn && <React.Fragment>
                        <a href="/login" id="loginbtn" className="header--btns greyed">LOGIN</a>
                        <a href="/signup" id="signupbtn" className="header--btns">SIGN UP</a>
                    </React.Fragment>}
                    </div>
                </div>
            </div>
        </section>
      </header>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Header/index.js